import React from 'react';
import {
  AppBar,
  Toolbar,
  Link as HardLink,
  Menu,
  MenuItem,
  Button,
  IconButton,
  Divider,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import { useAuth } from '../../teal-react/utils/token';
import MenuIcon from '@mui/icons-material/Menu';
import { Logout, Password, PeopleAlt, Token } from '@mui/icons-material';
import ExcludeReadOnly from '../Auth/ExcludeReadOnly';
import AdminOnly from '../Auth/AdminOnly';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  alignItems: 'center',
  // justifyContent: 'center',
  paddingTop: theme.spacing(0),
  // paddingBottom: theme.spacing(2),
  // padding: '.5rem 1rem',
  backgroundColor: '#f8f9fa',
  // Override media queries injected by theme.mixins.toolbar
  fontFamily: 'Helvetica',
  '@media all': {
    minHeight: 50,
  },
}));

const MainNav = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState(0);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    index: number
  ) => {
    setAnchorEl(event.currentTarget);
    setOpen(index);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(0);
  };
  return (
    <AppBar>
      <StyledToolbar>
        <Button
          style={{ fontSize: 'x-large', marginRight: '1em' }}
          onClick={() => navigate('/')}
        >
          <img src="/pluscologo.png" style={{ height: 30 }} alt="logo" />
        </Button>
        <Button onClick={() => navigate('/products')}>Products</Button>
        <ExcludeReadOnly>
          <div>
            <Button onClick={(e) => handleMenuOpen(e, 1)}>Bins</Button>
            <Menu
              anchorEl={open === 1 ? anchorEl : null}
              open={open === 1}
              onClose={handleClose}
            >
              <HardLink underline="none" href="/html/binSearch.php">
                <MenuItem>Bin Info</MenuItem>
              </HardLink>
              <HardLink underline="none" href="/html/binInventory.php">
                <MenuItem>Bin Inventory Update</MenuItem>
              </HardLink>
            </Menu>
          </div>
          <Button onClick={(e) => handleMenuOpen(e, 4)}>Other</Button>
          <Menu
            anchorEl={open === 4 ? anchorEl : null}
            open={open === 4}
            onClose={handleClose}
          >
            <HardLink underline="none" href="/html/equivilentSearch.php">
              <MenuItem>Equivalents</MenuItem>
            </HardLink>
            <HardLink underline="none" href="/html/equivilent.php">
              <MenuItem>Equivalent Register</MenuItem>
            </HardLink>
            <HardLink underline="none" href="/materials">
              <MenuItem>Material Usage</MenuItem>
            </HardLink>
          </Menu>
          <Button onClick={(e) => handleMenuOpen(e, 2)}>Beta</Button>
          <Menu
            anchorEl={open === 2 ? anchorEl : null}
            open={open === 2}
            onClose={handleClose}
          >
            <HardLink underline="none" href="/html/orderInput1.php">
              <MenuItem>New Order / Change Order</MenuItem>
            </HardLink>

            <HardLink underline="none" href="/html/orderFulfilment.php">
              <MenuItem>Order Fulfillment</MenuItem>
            </HardLink>

            <HardLink underline="none" href="/html/shipping_verification.php">
              <MenuItem>Shipping Verification</MenuItem>
            </HardLink>

            <HardLink underline="none" href="/html/deliversheet.php">
              <MenuItem>Deliver Sheet</MenuItem>
            </HardLink>

            <HardLink underline="none" href="/html/orders1.php">
              <MenuItem>Packing Slip</MenuItem>
            </HardLink>

            <HardLink underline="none" href="/html/customer_info.php">
              <MenuItem>Customer Information</MenuItem>
            </HardLink>

            <HardLink underline="none" href="/html/receiving.php">
              <MenuItem>Raw Material Receiving Record</MenuItem>
            </HardLink>

            <HardLink underline="none" href="/html/rawmaterialsearch.php">
              <MenuItem>Raw Material Search</MenuItem>
            </HardLink>
          </Menu>
        </ExcludeReadOnly>
        <div style={{ flexGrow: 1 }} />
        <IconButton onClick={(e) => handleMenuOpen(e, 3)}>
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={open === 3 ? anchorEl : null}
          open={open === 3}
          onClose={handleClose}
        >
          {user?.isDev ? (
            <>
              <MenuItem
                onClick={() => {
                  handleClose();
                  navigate('/Test');
                }}
              >
                Test Page
              </MenuItem>
            </>
          ) : null}
          <AdminOnly>
            <MenuItem
              onClick={() => {
                handleClose();
                navigate('/users');
              }}
            >
              <ListItemIcon>
                <PeopleAlt />
              </ListItemIcon>
              <ListItemText>User Management</ListItemText>
            </MenuItem>
          </AdminOnly>

          <ExcludeReadOnly>
            <MenuItem
              onClick={() => {
                handleClose();
                navigate('/materials');
              }}
            >
              <ListItemIcon>
                <Token />
              </ListItemIcon>
              <ListItemText>Material Management</ListItemText>
            </MenuItem>
          </ExcludeReadOnly>

          <MenuItem
            onClick={() => {
              handleClose();
              navigate('/profile');
            }}
          >
            <ListItemIcon>
              <Password />
            </ListItemIcon>
            Change Password
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => navigate('/auth/logout')}>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </StyledToolbar>
    </AppBar>
  );
};

export default MainNav;
